import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
import QuestionNumber from './QuestionNumber';
import SurveyQuestion from './SurveyQuestion';

interface QuestionProps {
  current: number;
  total: number;
  question: string;
  isOptional: boolean;
  previousQuestion: () => void;
}

export const Question: React.FC<QuestionProps> = ({
  current, total, question, previousQuestion, isOptional,
}) => {

  const [animate, setAnimate] = useState(false);

  useEffect(() => {

    setAnimate(true);
    const timer = setTimeout(() => setAnimate(false), 500);

    return () => clearTimeout(timer);

  }, [current]);

  return (
    <div className={`${styles['combined-question']} ${animate ? styles['fade-in'] : ''}`}>
      <QuestionNumber current={current} total={total} onPreviousClick={previousQuestion} isOptional={isOptional}/>
      <SurveyQuestion question={question} />
    </div>
  );

};
